// Approximates SwiftUI's .buttonStyle(.bordered): a tinted capsule that takes
// its colour from the accent tint.

export interface BorderedButtonProps {
  onClick?: () => void;
  href?: string;
  children: React.ReactNode;
}

const STYLE =
  "inline-flex select-none items-center gap-1.5 whitespace-nowrap rounded-full bg-accent/15 px-3 py-2 text-[17px] font-medium text-accent transition-opacity duration-200 hover:opacity-75";

export default function BorderedButton(props: BorderedButtonProps) {
  if (props.href) {
    return <a href={props.href} target="_blank" rel="noopener noreferrer" className={STYLE}>
      {props.children}
    </a>
  }

  return <button type="button" onClick={props.onClick} className={STYLE}>
    {props.children}
  </button>
}
